import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from 'src/@shared/common-pages.service';
import { ResponseStatus } from 'src/@shared/enum';

@Component({
  selector: 'app-map-unlinked-supplier',
  templateUrl: './map-unlinked-supplier.component.html',
  styleUrls: ['./map-unlinked-supplier.component.scss'],
  standalone: false,
})
export class MapUnlinkedSupplierComponent {

  QBOCustomersList: any[] = [];
  isLoadingQBOCustomers:boolean = true;
  isVisibleDrawer: boolean = true;
  isMappingSupplier: boolean = false;
  QBOCustomerDetail:any;
  @Input() selectedUnmappedSupplier:any
  @Output() hideUnlinkedSupplierDrawer = new EventEmitter();

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService) {
    _fS.mapSupplierForm_fb()
  }
  ngOnInit(){
    this.getQBOCustomers();
  }
  getQBOCustomers() {
    this._cpS.GetUnmappedQboSuppliers().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.QBOCustomersList = response.result;
      }
      this.isLoadingQBOCustomers = false
    });
  }
  getCustomerDetails() {
    if (this._fS.mapSupplierForm.value.QBOCustomer) {
      this._cpS
        .GetInvestorDetailQBO(this._fS.mapSupplierForm.value.QBOCustomer)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.QBOCustomerDetail = response.result;
          }
        });
    }
  }
MapCustomerInQBO() {
  if(this._fS.mapSupplierForm.valid){
    this.isMappingSupplier = true;
    
    const requestBody = {
  "supplierCode": this.selectedUnmappedSupplier.code,
  "qboSupplierId":  this.QBOCustomerDetail.id,
  "qboSupplierName":  this.QBOCustomerDetail.investorDisplayName,
  "localSupplierId": this.selectedUnmappedSupplier.isRegistered ? this.selectedUnmappedSupplier.id : '',
  "retailSupplierId": !this.selectedUnmappedSupplier.isRegistered ? this.selectedUnmappedSupplier.id : '',
  "qboEntityId":  this.QBOCustomerDetail.qboEntityId
}
    this._cpS.MapRetailSupplierToQboCustomer(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.QBOCustomerDetail = response.result;

        this._cS.displayMessage('success', response.message);
        this.isMappingSupplier = false;
        
      this.handleCancel(response.result)
      } else {
        this._cS.displayMessage('error', response.message);
        this.isMappingSupplier = false;
      }
    });
  }else{
    this._cS.markFormGroupTouched(this._fS.mapSupplierForm);
  }
  }
   handleCancel(data?:any) {
    this.isVisibleDrawer = false;
    this.hideUnlinkedSupplierDrawer.emit({ hide: this.isVisibleDrawer, data: data });
  }
}
